const helpTranslations = {
  en: {
    pageTitle: "Help & FAQ",
    heroTitle: "We Are Here to Support You",
    heroDesc:
      "At Akaal Kids, we understand that parents may have questions before and during their child’s learning journey. Our Help & Support section is designed to provide clear guidance, reassurance, and timely assistance whenever needed.",
    faqTitle: "Frequently Asked Questions",
    faqs: [
      {
        question: "Who can join Akaal Kids?",
        answer: [
          "Akaal Kids is open to:",
          "Children from 5 years onwards",
          "Youth",
          "Adults",
          "Anyone interested in learning Gurmat with understanding and discipline is welcome.",
        ],
      },
      {
        question: "Is prior knowledge of Punjabi or Gurbani required?",
        answer: [
          "No.",
          "Students are placed according to their current understanding, not prior experience. Beginners are guided step by step.",
        ],
      },
      {
        question: "How are batches decided?",
        answer: [
          "Batches are:",
          "Level-based, not age-based",
          "Formed after a simple assessment of reading and comfort level",
          "Kept small for personal attention",
        ],
      },
      {
        question: "What if my child feels shy or nervous?",
        answer: [
          "Our environment is:",
          "Encouraging and pressure-free",
          "Respectful and supportive",
          "Teachers help children settle comfortably and gain confidence naturally.",
        ],
      },
      {
        question: "How many classes are conducted each week?",
        answer: [
          "Students attend:",
          "Regular structured classes each week",
          "Optional enrichment sessions for interested learners",
          "Exact schedules are shared after enrollment.",
        ],
      },
      {
        question: "Are classes safe and supervised?",
        answer: [
          "Yes. All classes are fully supervised.",
          "Classes are Conducted in a respectful Gurmat-based environment.",
          "Designed to ensure emotional and spiritual safety.",
        ],
      },
      {
        question: "How do parents receive progress updates?",
        answer: [
          "Parents receive:",
          "Regular feedback on reading and memorization.",
          "Guidance on how to support practice at home.",
          "Open communication with teachers when required.",
        ],
      },
      {
        question: "What if we face technical issues?",
        answer: [
          "If you experience:",
          "Internet problems",
          "Login or access issues",
          "Audio or video difficulties",
          "Our support team assists promptly via WhatsApp or email.",
        ],
      },
      {
        question: "Can batches be changed later?",
        answer: [
          "If required:",
          "Batch placement can be reviewed.",
          "Adjustments are made in the child’s best interest.",
          "Parent comfort and child progress are always prioritized.",
        ],
      },
    ],
    assistanceTitle: "Need Personal Assistance?",
    assistanceDesc:
      "If your question is not listed above, we are happy to help.",
    contact: {
      email: "akaalkids@gmail.com",
      whatsapp: "+91 62837 90049",
      website: "www.akaalkids.com",
    },
    assistanceNote: "Our team will respond with care and clarity.",
    commitmentTitle: "Our Commitment",
    commitmentDesc: "We believe learning Gurmat is a journey that requires:",
    commitmentPoints: ["Patience", "Guidance", "Partnership with parents"],
    commitmentFinal:
      "Akaal Kids is committed to walking this path with your family.",
  },
  pa: {
    pageTitle: "ਮਦਦ ਅਤੇ ਸਹਿਯੋਗ",
    heroTitle: "ਅਸੀਂ ਤੁਹਾਡੇ ਨਾਲ ਹਾਂ।",
    heroDesc:
      "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਮਾਤਾ-ਪਿਤਾ ਦੇ ਦਾਖਲੇ ਤੋਂ ਪਹਿਲਾਂ ਅਤੇ ਸਿੱਖਣ ਦੌਰਾਨ ਜੇ ਸਵਾਲ ਹੇਣਗੇ ਅਸੀ ਉਨ੍ਹਾਂ ਦੀ ਸਪਸ਼ਟ ਅਤੇ ਭਰੋਸੇਯੋਗ ਜਾਣਕਾਰੀ ਦੇਵਾਂਗੇ ।",
    faqTitle: "ਆਮ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
    faqs: [
      {
        question: "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ ਕੌਣ ਸ਼ਾਮਲ ਹੋ ਸਕਦਾ ਹੈ?",
        answer: [
          "ਅਕਾਲ ਕਿਡਜ਼ ਵਿੱਚ:",
          "5 ਸਾਲ ਤੋਂ ਉੱਪਰ ਬੱਚੇ",
          "ਨੌਜਵਾਨ",
          "ਬਾਲਗ",
          "ਸਾਰੇ ਸ਼ਾਮਲ ਹੋ ਸਕਦੇ ਹਨ।",
        ],
      },
      {
        question: "ਕੀ ਪਹਿਲਾਂ ਤੋਂ ਪੰਜਾਬੀ ਜਾਂ ਗੁਰਬਾਣੀ ਆਉਣੀ ਜ਼ਰੂਰੀ ਹੈ?",
        answer: [
          "ਨਹੀਂ।",
          "ਦਾਖਲਾ ਵਿਦਿਆਰਥੀ ਦੀ ਮੌਜੂਦਾ ਸਮਝ ਅਨੁਸਾਰ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
          "ਨਵੇਂ ਸਿੱਖਣ ਵਾਲਿਆਂ ਨੂੰ ਹੌਲੀ-ਹੌਲੀ ਮਾਰਗਦਰਸ਼ਨ ਦਿੱਤਾ ਜਾਂਦਾ ਹੈ।",
        ],
      },
      {
        question: "ਬੈਚ ਕਿਵੇਂ ਬਣਾਏ ਜਾਂਦੇ ਹਨ?",
        answer: [
          "ਬੈਚ:",
          "ਲੈਵਲ ਅਧਾਰਿਤ ਹੁੰਦੇ ਹਨ",
          "ਉਮਰ ਅਧਾਰਿਤ ਨਹੀਂ",
          "ਛੋਟੇ ਗਰੁੱਪਾਂ ਵਿੱਚ ਬਣਾਏ ਜਾਂਦੇ ਹਨ",
        ],
      },
      {
        question: "ਜੇ ਬੱਚਾ ਘਬਰਾਇਆ ਹੋਵੇ ਤਾਂ?",
        answer: [
          "ਸਾਡਾ ਮਾਹੌਲ:",
          "ਦਬਾਅ ਰਹਿਤ",
          "ਪ੍ਰੇਰਣਾ ਭਰਪੂਰ",
          "ਸਤਿਕਾਰਯੋਗ",
          "ਅਧਿਆਪਕ ਬੱਚਿਆਂ ਨੂੰ ਆਰਾਮ ਨਾਲ ਸਿੱਖਣ ਲਈ ਤਿਆਰ ਕਰਦੇ ਹਨ।",
        ],
      },
      {
        question: "ਹਫ਼ਤੇ ਵਿੱਚ ਕਿੰਨੀ ਕਲਾਸਾਂ ਹੁੰਦੀਆਂ ਹਨ?",
        answer: [
          "ਵਿਦਿਆਰਥੀਆਂ ਲਈ:",
          "ਨਿਯਮਿਤ ਕਲਾਸਾਂ",
          "ਇੱਛੁਕ ਬੱਚਿਆਂ ਲਈ ਵਾਧੂ ਗਤੀਵਿਧੀਆਂ",
          "ਪੂਰਾ ਸਮਾਂ-ਸਾਰਣੀ ਦਾਖਲੇ ਤੋਂ ਬਾਅਦ ਦਿੱਤੀ ਜਾਂਦੀ ਹੈ।",
        ],
      },
      {
        question: "ਕੀ ਕਲਾਸਾਂ ਸੁਰੱਖਿਅਤ ਹਨ?",
        answer: [
          "ਹਾਂ।",
          "ਸਾਰੀਆਂ ਕਲਾਸਾਂ:",
          "ਨਿਗਰਾਨੀ ਹੇਠ",
          "ਗੁਰਮਤਿ ਅਧਾਰਿਤ",
          "ਸੁਰੱਖਿਅਤ ਮਾਹੌਲ ਵਿੱਚ ਹੁੰਦੀਆਂ ਹਨ",
        ],
      },
      {
        question: "ਮਾਤਾ-ਪਿਤਾ ਨੂੰ ਤਰੱਕੀ ਬਾਰੇ ਕਿਵੇਂ ਪਤਾ ਲੱਗਦਾ ਹੈ?",
        answer: [
          "ਮਾਤਾ-ਪਿਤਾ ਨੂੰ:",
          "ਨਿਯਮਿਤ ਫੀਡਬੈਕ",
          "ਅਭਿਆਸ ਲਈ ਦਿਸ਼ਾ-ਨਿਰਦੇਸ਼",
          "ਅਧਿਆਪਕਾਂ ਨਾਲ ਸੰਪਰਕ ਦੀ ਸਹੂਲਤ ਮਿਲਦੀ ਹੈ।",
        ],
      },
      {
        question: "ਜੇ ਤਕਨੀਕੀ ਸਮੱਸਿਆ ਆਵੇ ਤਾਂ?",
        answer: [
          "ਇੰਟਰਨੈੱਟ, ਆਡੀਓ ਜਾਂ ਵੀਡੀਓ ਸੰਬੰਧੀ ਸਮੱਸਿਆ ਲਈ:",
          "ਵਟਸਐਪ",
          "ਈਮੇਲ",
          "ਰਾਹੀਂ ਤੁਰੰਤ ਸਹਾਇਤਾ ਦਿੱਤੀ ਜਾਂਦੀ ਹੈ।",
        ],
      },
      {
        question: "ਕੀ ਬਾਅਦ ਵਿੱਚ ਬੈਚ ਬਦਲਿਆ ਜਾ ਸਕਦਾ ਹੈ?",
        answer: [
          "ਲੋੜ ਪੈਣ ਤੇ ਬੈਚ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
          "ਬੱਚੇ ਦੀ ਸੁਵਿਧਾ ਅਨੁਸਾਰ ਫ਼ੈਸਲਾ ਲਿਆ ਜਾਂਦਾ ਹੈ।",
        ],
      },
    ],
    assistanceTitle: "ਹੋਰ ਮਦਦ ਚਾਹੀਦੀ ਹੈ?",
    assistanceDesc:
      "ਜੇ ਤੁਹਾਡਾ ਸਵਾਲ ਉੱਪਰ ਨਹੀਂ ਦਿੱਤਾ ਗਿਆ ਤਾਂ ਅਸੀਂ ਮਦਦ ਲਈ ਤਿਆਰ ਹਾਂ।",
    contact: {
      email: "akaalkids@gmail.com",
      whatsapp: "+91 62837 90049",
      website: "www.akaalkids.com",
    },
    assistanceNote: "ਸਾਡੀ ਟੀਮ ਧਿਆਨ ਅਤੇ ਸਪਸ਼ਟਤਾ ਨਾਲ ਜਵਾਬ ਦੇਵੇਗੀ।",
    commitmentTitle: "ਸਾਡਾ ਵਚਨ",
    commitmentDesc: "ਅਸੀਂ ਮੰਨਦੇ ਹਾਂ ਕਿ ਗੁਰਮਤਿ ਸਿੱਖਣਾ ਇੱਕ ਯਾਤਰਾ ਹੈ ਜਿਸ ਲਈ:",
    commitmentPoints: ["ਧੀਰਜ", "ਮਾਰਗਦਰਸ਼ਨ", "ਮਾਤਾ-ਪਿਤਾ ਨਾਲ ਭਾਗੀਦਾਰੀ"],
    commitmentFinal:
      "ਅਕਾਲ ਕਿਡਜ਼ ਤੁਹਾਡੇ ਪਰਿਵਾਰ ਨਾਲ ਇਹ ਯਾਤਰਾ ਤੈਅ ਕਰਨ ਲਈ ਵਚਨਬੱਧ ਹੈ।",
  },
};

export default helpTranslations;
